import * as Actions from './member-correspondence-type.actions';
export const MemberCorrespondenceTypeActions = Actions;
